import React from "react";
import SupportChatComponent from "../../UI/SupportChat";

const SupportChat = () => {
  return (
    <div>
      <SupportChatComponent />
    </div>
  );
};

export default React.memo(SupportChat);
